import {
  ClientCommunicationListingModel,
  IClientCommunicationListingModel,
} from '@common/models';
import { ServiceHelper } from '@common/services/serviceHelper';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class ClientCommunicationsService {
  private static baseUrl = '/api/client';

  public static tags = {
    markCommunicationsAsRead: 'markCommunicationsAsRead',
    markCommunicationsAsUnread: 'markCommunicationsAsUnread',
    getClientCommunication: 'getClientCommunication',
  };

  static markCommunicationsAsRead = (
    clientId: number,
    storeId: number,
  ): Promise<void> => {
    return trackPromise(
      new Promise<void>((resolve, reject) => {
        http(
          `${this.baseUrl}/${clientId}/store/${storeId}/communications/markAsRead`,
        )
          .post({})
          .then(() => resolve())
          .catch(() => reject());
      }),
      ServiceHelper.getTagForOptions(this.tags.markCommunicationsAsRead),
    );
  };

  static markCommunicationsAsUnread = (
    clientId: number,
    storeId: number,
  ): Promise<void> => {
    return trackPromise(
      new Promise<void>((resolve, reject) => {
        http(
          `${this.baseUrl}/${clientId}/store/${storeId}/communications/markAsUnread`,
        )
          .post({})
          .then(() => resolve())
          .catch(() => reject());
      }),
      ServiceHelper.getTagForOptions(this.tags.markCommunicationsAsUnread),
    );
  };

  static getClientCommunicationListing = (
    communicationId: number,
    clientId: string | undefined,
  ): Promise<ClientCommunicationListingModel> => {
    return trackPromise(
      new Promise<ClientCommunicationListingModel>((resolve, reject) => {
        http(
          `${this.baseUrl}/communication?communicationId=${communicationId}&clientId=${clientId}`,
        )
          .get<IClientCommunicationListingModel>()
          .then((data) => {
            const clientCommunicationListing =
              new ClientCommunicationListingModel(data);
            resolve(clientCommunicationListing);
          })
          .catch((error) => {
            reject(error);
          });
      }),
      ServiceHelper.getTagForOptions(this.tags.getClientCommunication),
    );
  };
}
